import { useParams } from 'react-router-dom';

type ParamKey = 'courseUuid' | 'assignmentUuid' | 'submissionUuid';

/**
 * Hook to ensure required route params are present.
 * Throws an error if any requested param is missing or undefined.
 * Returns an object containing only the requested params.
 */
export const useRequireParams = <T extends ParamKey>(requiredParams: readonly T[]): Record<T, string> => {
  const params = useParams();

  const result = {} as Record<T, string>;

  for (const key of requiredParams) {
    const value = params[key];
    if (!value) {
      throw new Error(`Required route param "${key}" is missing`);
    }
    result[key] = value;
  }

  return result;
};
